import React from 'react';
const IconMiscEye = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM8.99991 12C8.99991 10.34 10.3399 9 11.9999 9C13.6599 9 14.9999 10.34 14.9999 12C14.9999 13.66 13.6599 15 11.9999 15C10.3399 15 8.99991 13.66 8.99991 12Z" fill="#666666"/>
</svg>
);
};
export default IconMiscEye;